<template>
  <div class="index-notice container mb60">
    <div class="notice-title">
      <span>公告<br /><span class="text">资讯</span></span>
    </div>
    <div class="notice-list">
      <div class="swiper-container zixun">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in notice_list"
            :key="item.id"
            :data-index="index"
            @click="goDetail(item.id, item.is_ad)"
          >
            <span class="tip">[{{ item.catetitle }}]</span>{{ item.title }}
          </div>
        </div>

        <!-- 如果需要滚动条 -->
        <!--    <div class="swiper-scrollbar"></div>-->
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  props: ["notice_list"],
  data() {
    return {};
  },
  mounted() {
    new Swiper(".zixun", {
      loop: true
      // 如果需要分页器
      //pagination: ".swiper-pagination",
      // 如果需要前进后退按钮
      //nextButton: ".swiper-button-next",
      //prevButton: ".swiper-button-prev"
      // 如果需要滚动条
      // scrollbar: '.swiper-scrollbar',
      //如果需要自动切换海报
      // autoplay: {
      //   delay: 1000,//时间 毫秒
      //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
      // },
    });
  },
  methods: {
    goDetail(id, is_ad) {
      if (is_ad === 1) return false;
      uni.navigateTo({
        url: "/pages/news-detail/news-detail?id=" + id
      });
    }
  }
};
</script>
<style lang="less" scoped>
.index-notice {
  display: flex;
  .notice-title {
    font-size: 0.24rem;
    line-height: 0.28rem;
    width: auto;
    padding-right: 0.2rem;
    margin-right: 0.2rem;
    border-right: 0.01rem solid rgba(94, 94, 102, 0.5);
    color: #1b1c33;
    font-weight: bolder;
    text-align: left;
    .text {
      color: #ff545a;
    }
  }

  .notice-list {
    width: ~"calc(100% - 1.3rem)";
    font-size: 0.2rem;
    line-height: 0.28rem;
    height: 0.56rem;
    background: url(../../static/index/notice/notice-arrow-left.png) center
      right no-repeat;
    background-size: 0.15rem 0.26rem;
    padding-right: 0.3rem;
    display: inline-block;
    .swiper-slide {
      width: 100%;
      text-align: left;
    }

    .tip {
      color: #ff0000;
      width: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexnotice.vue